import 'ol/ol.css';
import {Map, View} from 'ol';
import {Tile as TileLayer, Image as ImageLayer} from 'ol/layer.js';
import TileWMS from 'ol/source/TileWMS.js';
import Attribution from 'ol/control/Attribution.js';
import {ScaleLine, defaults as defaultControls} from 'ol/control';

import {transform, Projection} from 'ol/proj.js';
import $ from 'jquery';

var attr = [
  new Attribution({
    html: '<a href="https://istina.msu.ru/profile/tsamsonov/">Timofey Samsonov</a>'+ ' (Lomonosov MSU Faulty of Geography),'
  }),
  new Attribution({
    html: '<a href="https://www.usgs.gov/">U.S. Geological Survey</a>'
  })
]

var format = 'image/png';

var hypso = new TileLayer({
  source: new TileWMS({
    ratio: 1,
    url: 'http://autolab.geogr.msu.ru:8080/geoserver/hypso/wms',
    params: {'FORMAT': format,
             'VERSION': '1.3.0',
          LAYERS: 'hypso_combo',
          STYLES: '',
    },
    attributions: attr
  }),
});

var center = [0, 0];

var view = new View({
  projection: 'EPSG:4326',
  center: center,
  zoom: 1,
  minZoom: 0,
  maxZoom: 9
});


var map = new Map({
  target: 'map',
  layers: [hypso],
  view: view,
  controls: defaultControls().extend([
    new ScaleLine({
      units: 'metric',
      minWidth: 100
    })
  ]),
});
